import { UpgradeExperienceCard } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: ()=>UpgradeExperienceCard,
  mapEntryToProps: (entry: MEMBERSHIP_MODELS.UpgradeExperienceCard) =>
    kontentAiDataMapping.upgrade_experience_card(entry),
    depthParameter: 3,
};
